import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@fluentui/react/lib/Image';
import {
  internalLinkStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getInstructionsStyles = (_, { palette = {} }) => ({
  instructionContent: {
    ...internalLinkStyle({ palette, isGreyBackground: false }),
  },
  imageContent: {
    marginBottom: 10,
  },
  buttons: {
    marginTop: '3%',
    marginBottom: '3%',
    paddingLeft: '3%',
    paddingRight: '3%',
  },
});

const Instructions = (props) => {
  const {
    title,
    descTemp,
    imageSrc,
    downloadInstructions,
    button,
    classes,
    i18n,
  } = props;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div>
        <div style={{
          paddingLeft: '3%',
          height: 'auto',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
        }}
        >
          <h6>{title}</h6>
        </div>
        {imageSrc ? <Image style={{ width: '100%' }} alt={i18n.getString(_TL_('Instructions image'))} src={imageSrc} className={classes.imageContent} /> : ''}
      </div>
      <div style={{ flexGrow: 1, overflow: 'hidden' }}>
        <div
          className={classes.instructionContent}
          style={{
            paddingLeft: '3%',
            paddingRight: '3%',
            height: '100%',
            overflow: 'auto',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
          }}
        >
          {descTemp}
        </div>
      </div>
      <div style={{
        paddingLeft: '3%',
        paddingRight: '3%',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        marginTop: '20px',
      }}
      >
        <b>{downloadInstructions}</b>
      </div>
      <div style={{
        paddingLeft: '3%',
        paddingRight: '3%',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        marginTop: '20px',
        marginBottom: '20px',
      }}
      >
        <div style={{ whiteSpace: 'normal', fontSize: '12px' }}>
          {button}
        </div>
      </div>
    </div>
  );
};

Instructions.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    instructionContent: PropTypes.string,
    imageContent: PropTypes.string,
    buttons: PropTypes.string,
  }).isRequired,
  title: PropTypes.string.isRequired,
  descTemp: PropTypes.element,
  button: PropTypes.element.isRequired,
  downloadInstructions: PropTypes.string,
  imageSrc: PropTypes.string,
};

Instructions.defaultProps = {
  descTemp: null,
  imageSrc: '',
  downloadInstructions: '',
};

export const StyledInstructions = withDefaultStyles(
  Instructions,
  getInstructionsStyles
);
